// Copy and destination for the Bambee 2.0 migration banner (BIO-1908).
//
// Kept out of the component so a content drop is a one-line edit rather than a change to the
// banner itself. Copy and the scheduling link came from Alicia on the ticket (2026-09-17).
//
// OPEN QUESTION carried from BIO-1908: the CTA reads "choose your new plan" but `ctaUrl` books a
// coverage-advisor call. Those promise different things. When the in-product migration flow
// lands, `ctaUrl` should point at it instead — which keeps that switch a content change.

const migrationBanner = {
  // Dismissal is keyed on this (Phase 3). Bump it to re-show the banner to everyone who has
  // already dismissed — the lever for the run-up to a wave's move date.
  version: '2026-09-18',
  message: `Meet the new Bambee.`,
  description: `Get ahead of workforce issues with an always-current handbook, continuous compliance support, and a dedicated HR team that knows your company.`,
  ctaLabel: `See what's changing and choose your new plan`,
  ctaUrl: `https://calendly.com/d/dz82-twx-r5q/coverage-advisor-meeting`,
} as const;

export default migrationBanner;
